import { ReactNode } from 'react';
import styled from 'styled-components';

import { Button } from '@components/Button';
import { Modal } from '@components/Modal';
import { useClientEnvironment } from '@hooks/clientEnvironment';
import { UseModalVisibilityHookReturn } from '@hooks/shared/useModalVisibility';

type UnderAgeModalProps = {
  modalVisibility: UseModalVisibilityHookReturn;
  header: string;
  bodyContent: ReactNode;
};
export const ThankyouModal = ({
  modalVisibility: { hideModal, isVisible },
  header,
  bodyContent,
}: UnderAgeModalProps): JSX.Element => {
  
  const { data: clientEnvironment } = useClientEnvironment();
  const { 
    isEveryset,
    name: clientName,
    client_domain: clientDomain,
  } = clientEnvironment || {};

  return (
    <StyledModal
      open={isVisible}
      onCancel={hideModal}
      footer={null}
      width={450}
    >
      <StyledHeader isEveryset={isEveryset}>
        <p>{header}</p>
      </StyledHeader>
      <StyledContent>
        {bodyContent}
        <div className='button-container'>
          <StyledButton href={clientDomain} target='_blank'>
            Explore {clientName}
          </StyledButton>
        </div>
      </StyledContent>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  .ant-modal-close {
    top: 10px;
    right: 14px;
    width: 20px;
    height: 20px;

    .ant-modal-close-x {
      width: 100%;
      height: 100%;

      svg {
        width: 100%;
        height: 100%;
        path {
          stroke: #ffffff;
        }
      }
    }
  }
  .ant-modal-body {
    padding: 0;
  }
`;

const StyledHeader = styled.div<{ isEveryset: boolean }>`
  height: 128px;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: ${({ theme, isEveryset }) =>
    isEveryset
      ? `linear-gradient(96.66deg, #435ce0 3.44%, ${theme.palette.primary[0]} 99.44%)`
      : `linear-gradient(96.66deg, #357ee0 3.44%, ${theme.palette.primary[0]} 99.44%)`};

  p {
    margin: 0;
    color: #ffffff;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    text-align: center;
  }
`;

const StyledContent = styled.div`
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  p {
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
  }

  div.button-container {
    display: flex;
    justify-content: center;
  }
`;

const StyledButton = styled(Button)`
  &.ant-btn.ant-btn-default {
    border: 1px solid ${({ theme }) => theme.palette.stroke[0]};
    height: 32px;
    background-color: #ffffff;
    box-shadow: none;
  }
`;
